import { ArrowRight, Eye, GitBranch, Layers3, MousePointer2 } from "lucide-react"
import { SectionShell } from "@/components/design-system/SectionShell"
import { Badge } from "@/components/ui/badge"

const principles = [
  {
    icon: Eye,
    title: "Begin with attention",
    body: "Open on changed state, blocked work, and decisions due. Do not make users inspect every module to discover what matters.",
  },
  {
    icon: GitBranch,
    title: "Keep the thread",
    body: "Every commercial or production value retains its source, revision, evidence, author, and approval as it moves downstream.",
  },
  {
    icon: MousePointer2,
    title: "One dominant next move",
    body: "Each working surface exposes one primary action. Secondary actions stay available without competing for attention.",
  },
  {
    icon: Layers3,
    title: "Reveal depth in place",
    body: "Use drawers, inline disclosure, and stable lenses before sending users to another page or interrupting them with a modal.",
  },
]

export function ExperiencePrinciplesSection() {
  return (
    <SectionShell
      id="experience-principles"
      title="Experience principles"
      description="The UX rules that make Contracting OS feel like one operating system instead of a collection of modules."
      preview={
        <div className="grid gap-px overflow-hidden rounded-xl border bg-border md:grid-cols-2">
          {principles.map(({ icon: Icon, title, body }) => (
            <article key={title} className="min-h-56 bg-card p-6">
              <Icon className="size-5 text-muted-foreground" aria-hidden />
              <h3 className="mt-12">{title}</h3>
              <p className="mt-3 max-w-md text-sm text-muted-foreground">{body}</p>
            </article>
          ))}
        </div>
      }
      whenToUse={<ul><li>Use these rules when defining a page, workflow, or new primitive.</li><li>Make state, provenance, and consequence explicit.</li></ul>}
      whenNotToUse={<ul><li>Do not optimize a screen for module completeness.</li><li>Do not add navigation when contextual disclosure will preserve orientation.</li></ul>}
      options={
        <div className="flex flex-wrap items-center gap-2">
          <Badge tone="muted">Orient</Badge><ArrowRight className="size-3 text-muted-foreground" />
          <Badge tone="muted">Understand</Badge><ArrowRight className="size-3 text-muted-foreground" />
          <Badge tone="muted">Decide</Badge><ArrowRight className="size-3 text-muted-foreground" />
          <Badge tone="solid">Act</Badge>
        </div>
      }
    />
  )
}
